import { fetchAuthSession } from 'aws-amplify/auth'

const getBaseUrl = () => process.env.REACT_APP_API_URL

async function authHeaders() {
  const { tokens } = await fetchAuthSession()
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${tokens.idToken.toString()}`,
  }
}

export const api = {
  async getSreEvents(application, { start, end, pageSize = 50 } = {}) {
    const headers = await authHeaders()
    const params = new URLSearchParams({ page_size: pageSize })
    if (start) params.append('start', `${start}T00:00:00Z`)
    if (end) params.append('end', `${end}T23:59:59Z`)
    const res = await fetch(`${getBaseUrl()}/sre/${application}?${params}`, { headers })
    if (!res.ok) throw new Error('Failed to fetch SRE events')
    return res.json()
  },

  async deleteSreEvent(application, sreTimestamp) {
    const headers = await authHeaders()
    const res = await fetch(
      `${getBaseUrl()}/sre/${application}/${encodeURIComponent(sreTimestamp)}`,
      { method: 'DELETE', headers }
    )
    if (!res.ok) throw new Error('Failed to delete SRE event')
    return res.status
  },
}
